import { render } from "./CddProviderLogo.vue?vue&type=template&id=2ed9a24e"
import script from "./CddProviderLogo.vue?vue&type=script&lang=js"
export * from "./CddProviderLogo.vue?vue&type=script&lang=js"

import "./CddProviderLogo.vue?vue&type=style&index=0&id=2ed9a24e&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__